require('../favorites/favoritesService');

angular.module('app.schedule.scheduleService', [
  'app.favorites.favoritesService'
])
  .factory('app.schedule.scheduleService', [
    '$http', '$httpParamSerializerJQLike', 'app.favorites.favoritesService', '$q', '$location',
    function ($http, $httpParamSerializerJQLike, favorites, $q, $location) {
      let service = {
        schedule: {
          list: null,
          count: null,
          current_page: null,
          page_count: null,
          error: null,
          default_params: {
            search_id: null,
            type: null,
            date_disabled: false,
            start_date: moment().format('YYYY-MM-DD'),
            end_date: null,
            limit: 10,
            limit_favorites: true,
            sort: "asc",
            use_current_time: true,
            current_date_time: null,
            search_term: null,
          },
          current_params: null,
          searcher: null,
          search_name: null,
          retrieving: false,
          upcoming_schedule: null,

          reset_params: function () {
            return service.schedule.current_params = angular.copy(service.schedule.default_params);
          },
          merge_params: (params) => {
            service.schedule.current_params = angular.merge({}, service.schedule.current_params, params);
          },
          _debounceRetrieve: _.debounce((deferred, params, options) => {
            if (!options) {
              options = {};
            }

            if (service.schedule.retrieving) {
              deferred.reject({error: 'Already retrieving schedule'});
            } else {
              service.schedule.retrieving = true;

              if (service.schedule.searcher) {
                service.schedule.searcher.resolve();
              }
              service.schedule.searcher = $q.defer();
              if (service.schedule.current_params === null) {
                service.schedule.current_params = service.schedule.default_params;
              }
              if (typeof params === 'undefined') {
                params = service.schedule.current_params;
              } else {
                params = angular.merge({}, service.schedule.current_params, params);
                service.schedule.current_params = params;
              }

              if (service.schedule.current_page) {
                params.offset = (service.schedule.current_page - 1) * params.limit;
              }

              if (favorites.hasSelected()) {
                params.favorites = favorites.selected;
              } else {
                if(params.favorites) {
                  delete params.favorites;
                }
              }

              if (!service.upcoming_schedule) {
                params.limit_favorites = !!favorites.hasSelected();
              }

              if (typeof params.start_date === "string") {
                params.start_date = moment(params.start_date);
              }
              if (typeof params.end_date === "string") {
                params.end_date = moment(params.end_date);
              }

              params.start_date = momentToDate(params.start_date);
              params.end_date = momentToDate(params.end_date);

              if (params.start_date) {
                let today = new Date();
                params.use_current_time = params.use_current_time
                  && params.start_date.toDateString() === today.toDateString()
                  && !params.limit_favorites
                  && !params.search_id
                  && !params.date_disabled
                  && !service.upcoming_schedule;

                params.start_date = params.start_date.getFullYear() + "-" +
                  _.padStart(params.start_date.getMonth() + 1, 2, "0") + "-" +
                  _.padStart(params.start_date.getDate(), 2, "0") + " 00:00:00";

                if(params.use_current_time) {
                  params.current_date_time = today;

                  params.current_date_time = params.current_date_time.getFullYear() + "-" +
                    _.padStart(params.current_date_time.getMonth() + 1, 2, "0") + "-" +
                    _.padStart(params.current_date_time.getDate(), 2, "0") +
                    " " +
                    _.padStart(params.current_date_time.getHours(), 2, "0") +
                    ":" +
                    _.padStart(params.current_date_time.getMinutes(), 2, "0") +
                    ":00";
                } /*else {
                  params.current_date_time = null;
                }*/
              }
              if (params.end_date) {
                params.end_date =
                  params.end_date.getFullYear() + "-" +
                  _.padStart(params.end_date.getMonth() + 1, 2, "0") + "-" +
                  _.padStart(params.end_date.getDate(), 2, "0") + " 23:59:59";
              }

              params.omit_count = service.schedule.current_page > 1 ? params.omit_count : null; //fixes the display of correct number of pages

              let query_params = $httpParamSerializerJQLike(params);
              $http.get(window.location.api('schedule/search?' + query_params))
                .then((response) => {
                    let data = response.data;
                    let prop;

                    service.schedule.list = {};
                    service.schedule.error = null;

                    if(_.isInteger(data.current_time_games_offset)) {
                      service.schedule.current_params.offset = data.current_time_games_offset;
                    }

                    service.schedule.current_page = Math.floor(service.schedule.current_params.offset / service.schedule.current_params.limit) + 1;

                    if (data.results) {
                      let results_keys = [];

                      if(params.hasOwnProperty("sort")) {
                        switch (params.sort) {
                          case "desc":
                            results_keys = Object.keys(data.results).sort(function(a,b) {
                              if(moment(b).toDate().valueOf() > moment(a).toDate().valueOf()) {
                                return 1;
                              } else if (moment(b).toDate().valueOf() == moment(a).toDate().valueOf()) {
                                return 0;
                              } else {
                                return -1;
                              }
                            });
                            break;
                          case "asc":
                          default:
                            results_keys = Object.keys(data.results).sort(function(a,b) {
                              if(moment(a).toDate().valueOf() > moment(b).toDate().valueOf()) {
                                return 1;
                              } else if (moment(a).toDate().valueOf() == moment(b).toDate().valueOf()) {
                                return 0;
                              } else {
                                return -1;
                              }
                            });
                            break;
                        }
                      }

                      // The results come back from the API keyed by date.
                      results_keys.forEach(function (dateKey) {
                        // The games themselves are in UTC time. We'll need to adjust those to show in the users timezone.
                        angular.forEach(data.results[dateKey], function (result) {
                          let localDt = new Date(result.dtegametimefixed);
                          result.dtegametimefixed = localDt;

                          // Get the localized date key
                          let md = moment(localDt);
                          let localDateKey = md.format("YYYY-MM-DD");
                          if (!service.schedule.list.hasOwnProperty(localDateKey)) {
                            service.schedule.list[localDateKey] = [];
                          }

                          service.schedule.list[localDateKey].push(result);
                        });
                      });
                    }
                    if (data.count) {
                      service.schedule.count = data.count;
                    }
                    if (data.error) {
                      service.schedule.error = data.error;
                    }
                    if (data.start_date) {
                      service.schedule.current_params.start_date = data.start_date;
                    }
                    if (data.end_date) {
                      service.schedule.current_params.end_date = data.end_date;
                    }
                    if (data.search_name) {
                      service.schedule.search_name = data.search_name;
                    }

                    service.schedule.page_count = service.schedule.count / service.schedule.current_params.limit;

                    if (!service.schedule.error) {
                      service.schedule.error = 'No results found.';
                      if (service.schedule.list) {
                        for (prop in service.schedule.list) {
                          if (service.schedule.list.hasOwnProperty(prop)) {
                            service.schedule.error = null;
                            break;
                          }
                        }
                      }
                    }
                    service.schedule.searcher = null;

                    deferred.resolve(response);
                    service.schedule.retrieving = false;
                  },
                  () => {
                    service.schedule.searcher = null;
                    deferred.reject(response);
                    service.schedule.retrieving = false;
                  }
                );
            }

            if (options.saveToHistory && !_.isEmpty(params)) {
              $location.search("scheduleSearch=" + JSON.stringify(params));
            }
          }, 200),
          retrieve: (params, options) => {
            let deferred = $q.defer();

            service.schedule._debounceRetrieve(deferred, params, options);

            return deferred.promise;
          },
          retrievePage: () => {
            return service.schedule.retrieve({omit_count: true, use_current_time: false});
          },
          isUpcomingSchedule: (param) => {
            service.upcoming_schedule = param;
          }
        }
      };

      return service;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/schedule/scheduleService.js